import * as React from "react"
import { Slot } from "radix-ui"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-semibold transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 active:scale-95 cursor-pointer",
  {
    variants: {
      variant: {
        default:
          "gradient-primary text-white shadow-lg shadow-primary/20 hover:brightness-110",
        secondary:
          "bg-surface-container-highest text-on-surface hover:bg-surface-bright",
        destructive:
          "bg-error-container text-on-error-container hover:brightness-125",
        ghost:
          "text-on-surface-variant hover:bg-surface-container-highest hover:text-on-surface",
        outline:
          "ring-1 ring-outline-variant/30 text-on-surface hover:bg-surface-container-highest",
        link: "text-primary-text underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-5 py-2.5 rounded-lg",
        sm: "h-8 px-4 py-2 rounded-lg text-xs",
        lg: "h-12 px-8 py-3 rounded-lg text-base",
        icon: "h-10 w-10 rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
  }) {
  const Comp = asChild ? Slot.Root : "button"

  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
